export enum ActionType {
  GET_STORES = 'GET_STORES',
  GET_STORES_REJECTED = 'GET_STORES_REJECTED',
  GET_STORES_FULFILLED = 'GET_STORES_FULFILLED',
  GET_MORE_STORES = 'GET_MORE_STORES',
  GET_MORE_STORES_REJECTED = 'GET_MORE_STORES_REJECTED',
  GET_MORE_STORES_FULFILLED = 'GET_MORE_STORES_FULFILLED',
  GET_STORE = 'GET_STORE',
  GET_STORE_REJECTED = 'GET_STORE_REJECTED',
  GET_STORE_FULFILLED = 'GET_STORE_FULFILLED',
  ADD_STORE = 'ADD_STORE',
  ADD_STORE_REJECTED = 'ADD_STORE_REJECTED',
  ADD_STORE_FULFILLED = 'ADD_STORE_FULFILLED',
  EDIT_STORE = 'EDIT_STORE',
  EDIT_STORE_REJECTED = 'EDIT_STORE_REJECTED',
  EDIT_STORE_FULFILLED = 'EDIT_STORE_FULFILLED',
  DELETE_STORE = 'DELETE_STORE',
  DELETE_STORE_REJECTED = 'DELETE_STORE_REJECTED',
  DELETE_STORE_FULFILLED = 'DELETE_STORE_FULFILLED',
}
export default ActionType;
